import {
    forloebOverviewMenuLink,
    brugereMenuLink,
    evalueringsstatistikMenuLink,
    nyhederMenuLink,
    vejledereMenuLink,
    fileAdministrationMenuLink,
    uddannelseslaegeOverviewMenuLink,
    kursusoversigtMenu
} from "core/layout/shared/MenuLinkProps";
import { DynamicMenu } from "../DynamicMenu";
import MenuProps from "./menuProps";

export function SekretaerMenu({ showNotification, nyhederMenuLink }: MenuProps) {

    const menuLinks = [
        forloebOverviewMenuLink,
        uddannelseslaegeOverviewMenuLink,
        vejledereMenuLink,
        brugereMenuLink,
        evalueringsstatistikMenuLink,
        nyhederMenuLink,
        fileAdministrationMenuLink,
        kursusoversigtMenu
    ];

    return (
        <DynamicMenu menuLinks={menuLinks} showNotifications={showNotification}/>
    );

}
